/* ─── Status colour map ──────────────────────────────────────────────────── */
export const STATUS_COLORS = {
  online:  '#23a559',
  idle:    '#f0b232',
  dnd:     '#f23f43',
  offline: '#80848e',
};

/* ─── Activity type → emoji ──────────────────────────────────────────────── */
export const ACTIVITY_EMOJI = {
  playing:   '🎮',
  listening: '🎵',
  coding:    '💻',
  calendar:  '📅',
  idle:      '💤',
  call:      '📞',
};

/* ─── Source label ───────────────────────────────────────────────────────── */
export const SOURCE_LABELS = {
  discord:  'via Discord',
  steam:    'via Steam',
  calendar: 'via Calendar',
};
